exports.SHA = require('./sha');
exports.HMAC = require('./hmac');
exports.CRC32 = require('./crc32');
